import { useSelector } from 'react-redux';

const useIsSeller = () => {
  const primaryInterest = useSelector(state => state.auth.currentUser.primary_interest);
  return primaryInterest === 'sell';
};

export default useIsSeller;
